import '/modules/extended_report/css/timeseries/GDORDriaChart.css';
import '/modules/extended_report/css/timeseries/GDORDriaChart.responsive.css';
import * as $ from "jquery";
import {dateFromStr, formatDate} from "../../common/time/TimeCalculator";
import {formatNumber, prefixUrl} from "../../common/util";
import {NavigableIndicatorChart} from "./NavigableIndicatorChart";

/**
 * Chart element for RDrIA
 * @extends NavigableIndicatorChart
 * @hideconstructor
 */
class GDORDrIaChart extends NavigableIndicatorChart {

    /**
     *
     * @param id {string} An HTML id for this indicator chart
     * @param translator {Translator} A translator
     * @param gdordriaValuesUrl {string}
     * @param gdordriaMapImgUrl {string}
     * @param indicator {Indicator} The indicator of this chart
     * @param until {Date} The end date for the chart is fixed
     * @param infoModal {Modal} A modal window to show indicator metadata in
     * @param runtimeConfig {RuntimeConfig} The map runtime config
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     */
    constructor(id, translator, gdordriaValuesUrl, gdordriaMapImgUrl, indicator, until, infoModal, runtimeConfig, isMobileDevice) {
        super(id, translator, indicator, until, infoModal, runtimeConfig, isMobileDevice);
        this.gdordriaValuesUrl = gdordriaValuesUrl;
        this.gdordriaMapImgUrl = gdordriaMapImgUrl;
    }

    getClassName(){
        return "GDORDrIaChart";
    }

    _getSimpleStatsShower(data) {
        return undefined;
    }

    /**
     *
     * @param until {Date} The date until when to show data
     * @param wgs84Coords {Array<number>} 2 position array with coords lon lat in wgs84
     * @param mapImgUrl {string} The URL for the map image
     * @param aruId {string} The id of the chart region
     * @param regionArea {number} The area of the chart region (m2)
     * @param countryCode {string} The id of the city
     */
    setChartParams(until, wgs84Coords, mapImgUrl, aruId, regionArea, countryCode) {
        this.aruId = aruId;
        this.regionArea = regionArea;
        this.countryCode = countryCode;
        this.mapImgUrl = mapImgUrl;
        if (this.imgComparisonLoaded) {
            this.imgComparisonLoaded = false;
            this._updateComparisonImages();
        }
        super.setUntilAndCoords(until, wgs84Coords, true);
    }

    _extractChartData(dataFromService) {
        const alerts = dataFromService.features[0].properties.alerts;
        const valsForProcessor = {};
        Object.keys(alerts).forEach(dateStr => {
            const date = dateFromStr(dateStr.slice(0, 4) + '-' + dateStr.slice(4, 6) + '-' + dateStr.slice(6, 8));
            if (alerts[dateStr]) {
                const low = alerts[dateStr]['1'] ? alerts[dateStr]['1'].part : 0;
                const medium = alerts[dateStr]['2'] ? alerts[dateStr]['2'].part : 0;
                const high = alerts[dateStr]['3'] ? alerts[dateStr]['3'].part : 0;
                valsForProcessor[formatDate(date)] = {
                    '1': low * 100,
                    '2': medium * 100,
                    '3': high * 100,
                }
            } else {
                valsForProcessor[formatDate(date)] = null;
            }
        });
        return valsForProcessor;
    }

    _updateChart() {
        if (this.aruId && this.regionArea) {
            $.getJSON(this.gdordriaValuesUrl.format(["" + this.aruId]), fCol => {
                this.chartData = this._extractChartData(fCol);

                const imgContainer = $('.map-img-container', this.getUIElement());
                if (this.mapImgUrl) {
                    $('img.map-img', imgContainer).attr('src', prefixUrl(this.mapImgUrl));
                    imgContainer.show();
                } else {
                    imgContainer.hide();
                }

                const refDate = formatDate(this.layer.getTimeCalculator().fixDate(this.originalUntil)).replaceAll('-', '');
                const alert = fCol.features[0].properties.alerts[refDate];
                const affected = {};
                if (alert) {
                    Object.keys(alert).filter(a => a !== "0").forEach(a => affected[a] = {
                        area: alert[a].part * this.regionArea,
                        part: alert[a].part
                    });
                }

                const untilStr = formatDate(this.layer.getTimeCalculator().fixDate(this.originalUntil));
                const timeStr = this.translator.translate('tool.charts.stats.title', [this.layer.getTimeCalculator().timeCodeToString(untilStr).toLowerCase()]);

                const table = $(
                    '<div class="stats">' +
                    '   <table class="values">' +
                    '      <thead><tr><th>' + timeStr + '</th><th>' + this.translator.translate('tool.charts.stats.area') + '</th><th>' + this.translator.translate('tool.charts.stats.perc') + '</th></tr></thead>' +
                    '      <tbody></tbody>' +
                    '   </table>' +
                    '</div>'
                );
                Object.keys(affected).forEach(value => {
                    const label = this.layer.getChartStyler().getLabelFunction()(value);
                    const color = this.layer.getChartStyler().getColorFunction()(value);
                    $('tbody', table).append(
                        $('<tr><td><div class="color" style="background-color: ' + color + '"></div><label>' + label + '</label></td><td class="value">' + formatNumber(affected[value].area / 1000000, 2) + '</td><td class="value">' + formatNumber(affected[value].part * 100, 2) + '</td></tr>')
                    );
                });

                const partSum = Object.keys(affected).map(a => affected[a].part).reduce((p, c) => p + c, 0);
                $('tbody', table).append(
                    $('<tr><td><label>' + this.translator.translate('tool.charts.stats.totalAffected') + '</label></td><td class="value">' + formatNumber(this.regionArea * partSum / 1000000, 2) + '</td><td class="value">' + formatNumber(partSum * 100, 2) + '</td></tr>')
                );

                $('tbody', table).append(
                    $('<tr><td><label>' + this.translator.translate('tool.charts.stats.wholeReportingUnit') + '</label></td><td class="value">' + formatNumber(this.regionArea / 1000000, 2) + '</td><td></td></tr>')
                );

                $('.stats-container', this.getUIElement()).empty().append(table);

                super._updateChart();
            });
        }
    }

    getContainerElement() {
        const containerElement = super.getContainerElement()
            .addClass('map-img-chart').addClass('gdoria');
        $('.date-picker-chart-container', containerElement).removeClass('date-picker-chart-container');
        const statsAndChart = $('<div class="stats-chart-container"></div>');
        const stats = $('<div class="stats-container"></div>');
        statsAndChart.append(stats);
        const chartContainer = $('.chart-container', containerElement);
        chartContainer.addClass('date-picker-chart-container');
        containerElement.remove('.chart-container');
        statsAndChart.append(chartContainer);
        const img = $('<div class="map-img-container"><img alt="'+this.layer.getName()+'" class="map-img"/></div>');
        $('.body', containerElement).prepend(this._getImagesComparisonElement()).prepend(statsAndChart).prepend(img);
        if (!this.mapImgUrl) {
            img.hide();
        } else {
            $('img',img).attr('src',this.mapImgUrl);
        }
        return containerElement;
    }

    _getImagesComparisonElement() {
        const comparisonButton = $('<a class="img-comparison-controller">[' + this.translator.translate("tool.charts.gdordria.comparison.show") + ']</a>').click(() => {
            if (!this.imgComparisonLoaded) {
                this._updateComparisonImages();
            }
            $('.img-container', this.uiElement).toggle();

            if($('.img-container', this.uiElement).is(':visible'))
                this.logStat('SHOW_COMPARISON');
            else this.logStat('HIDE_COMPARISON');

        });
        const controllerDiv = $('<div class="img-comparison-controller-container"><h3>' + this.translator.translate("tool.charts.gdordria.comparison.title") + '</h3></div>')
            .append(comparisonButton);

        return $('<div class="img-comparison-container"></div>')
            .append(controllerDiv)
            .append($('<div class="img-container"></div>'));
    }

    _updateComparisonImages() {
        this.imgComparisonLoaded = true;
        const imgTarget = $('.img-container', this.uiElement).empty();
        let date = this.until;
        for (let i = 0; i < 9; i++) {
            const timeCode = formatDate(date);
            const formattedUrl = this.gdordriaMapImgUrl.format([
                timeCode,
                this.wgs84Coords[0]+"",
                this.wgs84Coords[1]+"",
                this.aruId,
                this.countryCode
            ]);
            const timeStr = this.layer.getTimeCalculator().timeCodeToString(timeCode);
            const imgElement = $('<div class="comparison-img"><div class="img-time">' + timeStr + '</div></div>')
                .addClass(timeCode === formatDate(this.originalUntil)?'original-until':'');
            imgTarget.prepend(imgElement);
            $.get(formattedUrl,(urls)=>{
                const img = $('<img width="300" alt="map ' + timeStr + '" src="' + prefixUrl(urls['main']) + '"/>');
                imgElement.prepend(img);
            });
            date = this.layer.getTimeCalculator().getPreviousDate(date);
        }
    }
}

export {GDORDrIaChart}